import { analyzeMenuDeprecatedRouteMap } from "./customer/analyze";
import { billingMenuDeprecatedRouteMap } from "./customer/billing";
import { integrateMenuDeprecatedRouteMap } from "./customer/integrate";
import { monitorMenuDeprecatedRouteMap } from "./customer/monitor";
import { operateMenuDeprecatedRouteMap } from "./customer/operate";
import { optimizeMenuDeprecatedRouteMap } from "./customer/optimize";
import { cloudIncidentsDeprecatedRouteMap } from "./doer/cloud-incidents";
import { removedDoerOnlyCustomerFeaturesDeprecatedRouteMap } from "./doer/removed-customer-features";

export const deprecatedRoutesMap = {
  // customer routes
  ...operateMenuDeprecatedRouteMap,
  ...analyzeMenuDeprecatedRouteMap,
  ...integrateMenuDeprecatedRouteMap,
  ...optimizeMenuDeprecatedRouteMap,
  ...monitorMenuDeprecatedRouteMap,
  ...billingMenuDeprecatedRouteMap,

  // doer routes
  ...cloudIncidentsDeprecatedRouteMap,
  ...removedDoerOnlyCustomerFeaturesDeprecatedRouteMap,
};
